import core, { View } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { BettingWidgets, SportEventMetaKey } from 'app-constants';
import { useMemoSelector, useWidgetSettings } from 'hooks';
import { selectIsSportEventViewable, selectRouteBySportEvent } from 'selectors';
import { ParentPath } from 'types';
import { checkIsMatchTrackerDisabled, checkIsSportEventViewable } from 'utils';

const {
    entities: {
        selectors: { selectMatch },
    },
    viewport: {
        selectors: { makeViewportSelector },
    },
} = core;

interface Input {
    sportEventId: string;
}

interface Output {
    match: View.Match | null;
    route: ParentPath;
    isStreamAvailable: boolean;
    isExtraSmall: boolean;
    isSmall: boolean;
    isMedium: boolean;
}

const useOverviewRow = ({ sportEventId }: Input): Output => {
    const { disableMatchTracker } = useWidgetSettings({
        widget: BettingWidgets.STREAM,
    });
    const {
        match,
        route,
        sportEventViewable: { hasValidBetradarId, hasValidStream },
        breakpoints,
    } = useMemoSelector(makeSelectProps(), {
        matchId: sportEventId,
        metaName: SportEventMetaKey.Server,
    });

    const { extraSmall, small, medium } = breakpoints;

    const isStreamAvailable = checkIsSportEventViewable({
        hasValidStream,
        hasValidBetradarId,
        isMatchTrackerDisabled: checkIsMatchTrackerDisabled(
            disableMatchTracker,
            match?.sportId
        ),
    });

    return {
        isStreamAvailable,
        match,
        route,
        isSmall: small,
        isMedium: medium,
        isExtraSmall: extraSmall,
    };
};

export default useOverviewRow;

const makeSelectProps = () => {
    return createStructuredSelector({
        match: selectMatch,
        route: selectRouteBySportEvent,
        sportEventViewable: selectIsSportEventViewable,
        breakpoints: makeViewportSelector('lessThanOrEqual'),
    });
};
